import { render, staticRenderFns } from "./LotteryForm.vue?vue&type=template&id=ba279eb8&scoped=true"
import script from "./LotteryForm.vue?vue&type=script&lang=ts"
export * from "./LotteryForm.vue?vue&type=script&lang=ts"
import style0 from "./LotteryForm.vue?vue&type=style&index=0&id=ba279eb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba279eb8",
  null
  
)

export default component.exports